export default __webpack_public_path__ + "static/media/puzzle-img.af277c46.svg";